import { render } from "./AppLogo.vue?vue&type=template&id=afffe2d6&scoped=true&lang=pug"
import script from "./AppLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLogo.vue?vue&type=script&setup=true&lang=js"

import "./AppLogo.vue?vue&type=style&index=0&id=afffe2d6&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afffe2d6"]])

export default __exports__